import { StrictMode } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './app/App'
import './index.css'

/**
 * `hydrateRoot`, not `createRoot`: every page is prerendered, so there is real
 * markup in `#root` and the job is to adopt it. `createRoot` would throw it away
 * and repaint, which is the flash-of-blank that makes prerendering pointless.
 */
hydrateRoot(
  document.getElementById('root')!,
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
